const vm = {
    "vm.title.block1": "虛擬",
    "vm.title.block2": "試戴",
    "vm.defineClassic": "DEFINE® CLASSIC 經典大地色系",
    "vm.defineFresh": "DEFINE® FRESH 大自然色系",
    "vm.learnmore": "了解更多",
    "vm.shownow": "立即預約驗配",
}

export default vm;